/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class IsValidUuidValidator extends BaseValidator {
	name(model) {
		return "Must be a valid UUID.";
	}

	logic(x, model, data) {
		if (x != null && x !== '') {
			if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(x)) {
				return true;
			} else {
				return false;
			}
		}

		return true;
	}

	message(model) {
		return "Must be a valid UUID. All letters must be lower case.";
	}
}